/**
 * CREATE Vessel Action
 * Handles initialization of create drawer
 */

/**
 * Initialize create drawer state
 */
export const initializeCreateDrawer = ({
  setDrawerType,
  setDrawerVisible,
  setSelectedRecord,
}) => {
  setDrawerType('create')
  setSelectedRecord({
    abbreviation: '',
    active: true,
    imoNumber: '',
    vesselName: '',
  })
  setDrawerVisible(true)
}
